var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main__faq"},[_c('h2',{staticClass:"main__faq__title"},[_vm._v("Часто задаваемые вопросы")]),_vm._l((_vm.faqs),function(faq,i){return _c('MainFaqComponentList',{key:i,attrs:{"faq":faq,"index":i,"open":faq.open},on:{"toggleOpen":_vm.toggleOpen}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }